import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import { dateTimeReportFormatter } from "../../fomatters/DateFormatter";
import { decimalInvertedReportFormatter } from "../../fomatters/DecimalFormatter";
import InputSelect from "../InputSelect";
import Report from "../Report";
import SubGroup from "../SubGroup";

const currentDate = new Date();
currentDate.setDate(currentDate.getDate() - 7);

const startDateValue = currentDate.toISOString().split("T")[0];
const endDateValue = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function WagersListing() {
  const [allPlacedDate, setAllPlacedDate] = useState(true);
  const onAllPlacedDateChange = useCallback(
    (event) => setAllPlacedDate(event.target.checked),
    []
  );

  const [startPlacedDate, setStartPlacedDate] = useState(startDateValue);
  const onStartPlacedDateChange = useCallback(
    (event) => setStartPlacedDate(event.target.value),
    []
  );

  const [endPlacedDate, setEndPlacedDate] = useState(endDateValue);
  const onEndPlacedDateChange = useCallback(
    (event) => setEndPlacedDate(event.target.value),
    []
  );

  const [allSettledDate, setAllSettledDate] = useState(true);
  const onAllSettledDateChange = useCallback(
    (event) => setAllSettledDate(event.target.checked),
    []
  );

  const [startSettledDate, setStartSettledDate] = useState(startDateValue);
  const onStartSettledDateChange = useCallback(
    (event) => setStartSettledDate(event.target.value),
    []
  );

  const [endSettledDate, setEndSettledDate] = useState(endDateValue);
  const onEndSettledDateChange = useCallback(
    (event) => setEndSettledDate(event.target.value),
    []
  );

  const [distributor, setDistributor] = useState("");
  const onDistributorChanged = useCallback(
    (event) => setDistributor(event.target.value),
    []
  );

  const [player, setPlayer] = useState("");
  const onPlayerChange = useCallback(
    (event) => setPlayer(event.target.value),
    []
  );

  const [user, setUser] = useState("");
  const onUserChange = useCallback((event) => setUser(event.target.value), []);

  const [station, setStation] = useState("");
  const onStationChanged = useCallback(
    (event) => setStation(event.target.value),
    []
  );

  const [ip, setIp] = useState("");
  const onIpChanged = useCallback((event) => setIp(event.target.value), []);

  const [sameIp, setSameIp] = useState(false);
  const onSameIpChange = useCallback(
    (event) => setSameIp(event.target.checked),
    []
  );

  const [higherThan, setHigherThan] = useState("");
  const onHigherThanChanged = useCallback(
    (event) => setHigherThan(event.target.value),
    []
  );

  const [agentFrom, setAgentFrom] = useState("");
  const onAgentFromChange = useCallback(
    (event) => setAgentFrom(event.target.value),
    []
  );

  const [agentTo, setAgentTo] = useState("");
  const onAgenToChange = useCallback(
    (event) => setAgentTo(event.target.value),
    []
  );

  const [orderBy, setOrderBy] = useState(0);
  const onOrderByChange = useCallback(
    (event) => setOrderBy(Number(event.target.value)),
    []
  );

  const [agentLine, setAgentLine] = useState(false);
  const onAgentLineChange = useCallback(
    (event) => setAgentLine(event.target.checked),
    []
  );

  const [freePlay, setFreePlay] = useState(false);
  const onFreePlayChange = useCallback(
    (event) => setFreePlay(event.target.checked),
    []
  );

  const [openPlay, setOpenPlay] = useState(false);
  const onOpenPlayChange = useCallback(
    (event) => setOpenPlay(event.target.checked),
    []
  );

  const [pastPost, setPastPost] = useState(false);
  const onPastPostChange = useCallback(
    (event) => setPastPost(event.target.checked),
    []
  );

  const [wagerStatus, setWagerStatus] = useState(0);
  const onWagerStatusChange = useCallback(
    (event) => setWagerStatus(Number(event.target.value)),
    []
  );

  const [playerType, setPlayerType] = useState(0);
  const onPlayerTypeChange = useCallback(
    (event) => setPlayerType(Number(event.target.value)),
    []
  );

  const [wagerPlaced, setWagerPlaced] = useState(0);
  const onWagerPlacedChange = useCallback(
    (event) => setWagerPlaced(Number(event.target.value)),
    []
  );

  const [withDetailsIn, setWithDetailsIn] = useState(0);
  const onWithDetailsInChange = useCallback(
    (event) => setWithDetailsIn(Number(event.target.value)),
    []
  );

  const [book, setBook] = useState("");
  const onBookChanged = useCallback((b) => setBook(b), []);
  const { values: books } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetBooks`,
  });

  const [group, setGroup] = useState("");
  const onGroupChanged = useCallback((g) => setGroup(g), []);
  const { values: groups } = useDataFormatterHook({
    addEmpty: true,
    value: "groupName",
    text: "groupName",
    path: `/Player/Grouping_GetList`,
  });

  const [office, setOffice] = useState("");
  const onOfficeChanged = useCallback((o) => setOffice(o), []);
  const { values: offices } = useDataFormatterHook({
    addEmpty: true,
    value: "officeName",
    text: "officeName",
    path: `/Player/Office_GetList`,
  });

  const [lineType, setLineType] = useState("");
  const onLineTypeChanged = useCallback((l) => setLineType(l), []);
  const { values: lineTypes } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/LineType/GetLineTypes`,
  });

  const [wagerType, setWagerTypes] = useState("");
  const onWagerTypesChanged = useCallback((w) => setWagerTypes(w), []);
  const { values: wagerTypes } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Wager/WagerType_GetNameList`,
  });

  const [sport, setSport] = useState("");
  const onSportChanged = useCallback((s) => setSport(s), []);
  const { values: sports } = useDataFormatterHook({
    addEmpty: true,
    value: "idSport",
    text: "sportName",
    path: `/Player/GetSports`,
  });

  const [league, setLeague] = useState("");
  const onLeagueChanged = useCallback((l) => setLeague(l), []);
  const { values: leagues } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/League/League_GetAllLeagues`,
  });

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <InputSelect
          variant="outlined"
          size="small"
          label="Office"
          name="name"
          data={offices}
          placeholder="DataFormatter"
          setSelectValue={onOfficeChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Group"
          name="name"
          data={groups}
          placeholder="DataFormatter"
          setSelectValue={onGroupChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Book"
          name="name"
          data={books}
          placeholder="DataFormatter"
          setSelectValue={onBookChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Line Type"
          name="name"
          data={lineTypes}
          placeholder="DataFormatter"
          setSelectValue={onLineTypeChanged}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Agent From"
          type="text"
          value={agentFrom}
          size="small"
          onChange={onAgentFromChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent To"
          type="text"
          value={agentTo}
          size="small"
          onChange={onAgenToChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Distributor"
          type="text"
          value={distributor}
          size="small"
          onChange={onDistributorChanged}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Player"
          type="text"
          value={player}
          size="small"
          onChange={onPlayerChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="User"
          type="text"
          value={user}
          size="small"
          onChange={onUserChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Station"
          type="number"
          value={station}
          size="small"
          onChange={onStationChanged}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="IP"
          type="text"
          value={ip}
          size="small"
          onChange={onIpChanged}
          InputLabelProps={{ shrink: true }}
        />
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              checked={sameIp}
              onChange={onSameIpChange}
              color="primary"
            />
          }
          label="Same IP"
        />
        <TextField
          required
          variant="outlined"
          label="Higher Than"
          type="number"
          value={higherThan}
          size="small"
          onChange={onHigherThanChanged}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Wager Type"
          name="name"
          data={wagerTypes}
          placeholder="DataFormatter"
          setSelectValue={onWagerTypesChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Sport"
          name="name"
          data={sports}
          placeholder="DataFormatter"
          setSelectValue={onSportChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="League"
          name="name"
          data={leagues}
          placeholder="DataFormatter"
          setSelectValue={onLeagueChanged}
          startValue={""}
        />
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              checked={agentLine}
              onChange={onAgentLineChange}
              color="primary"
            />
          }
          label="Bets From Agent"
        />
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              checked={freePlay}
              onChange={onFreePlayChange}
              color="primary"
            />
          }
          label="Free Play"
        />
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              checked={openPlay}
              onChange={onOpenPlayChange}
              color="primary"
            />
          }
          label="Open Play"
        />
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              checked={pastPost}
              onChange={onPastPostChange}
              color="primary"
            />
          }
          label="Past Post"
        />
        <div>
          <SubGroup title="Wager Status">
            <FormControl component="fieldset">
              <RadioGroup
                label
                value={wagerStatus}
                onChange={onWagerStatusChange}
                row
              >
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Both"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Graded"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Open"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
        <div>
          <SubGroup title="Player Type">
            <FormControl component="fieldset">
              <RadioGroup
                label
                value={playerType}
                onChange={onPlayerTypeChange}
                row
              >
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Both"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Normal"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Master"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
        <SubGroup
          title="Placed Date"
          className="grid grid-cols-2 col-span-2 p-4"
        >
          <div className="flex">
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={allPlacedDate}
                  onChange={onAllPlacedDateChange}
                  color="primary"
                />
              }
              label="All"
            />
            <TextField
              disabled={allPlacedDate}
              className="flex-1"
              required
              variant="outlined"
              id="gameDateTime"
              label="From"
              type="date"
              value={startPlacedDate}
              size="small"
              onChange={onStartPlacedDateChange}
              InputLabelProps={{ shrink: true }}
            />
          </div>
          <TextField
            disabled={allPlacedDate}
            required
            variant="outlined"
            id="gameDateTime"
            label="To"
            type="date"
            value={endPlacedDate}
            size="small"
            onChange={onEndPlacedDateChange}
            InputLabelProps={{ shrink: true }}
          />
        </SubGroup>
        <SubGroup
          title="Settled Date"
          className="grid grid-cols-2 col-span-2 p-4"
        >
          <div className="flex">
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={allSettledDate}
                  onChange={onAllSettledDateChange}
                  color="primary"
                />
              }
              label="All"
            />
            <TextField
              disabled={allSettledDate}
              className="flex-1"
              required
              variant="outlined"
              id="gameDateTime"
              label="From"
              type="date"
              value={startSettledDate}
              size="small"
              onChange={onStartSettledDateChange}
              InputLabelProps={{ shrink: true }}
            />
          </div>
          <TextField
            disabled={allSettledDate}
            required
            variant="outlined"
            id="gameDateTime"
            label="To"
            type="date"
            value={endSettledDate}
            size="small"
            onChange={onEndSettledDateChange}
            InputLabelProps={{ shrink: true }}
          />
        </SubGroup>
        <div>
          <SubGroup title="With Details In">
            <FormControl component="fieldset">
              <RadioGroup
                label
                value={withDetailsIn}
                onChange={onWithDetailsInChange}
                row
              >
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Both"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Normal"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Master"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
        <div>
          <SubGroup title="Wager Placed">
            <FormControl component="fieldset">
              <RadioGroup
                label
                value={wagerPlaced}
                onChange={onWagerPlacedChange}
                row
              >
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Both"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Phone"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Online"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
        <div>
          <SubGroup title="Order By">
            <FormControl component="fieldset">
              <RadioGroup label value={orderBy} onChange={onOrderByChange} row>
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Player"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Ticket"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
      </div>
      <Report
        exportCSV={false}
        groupBy="ticket"
        title="Wagers Listing Report"
        getUrl={() => "/Reports/Report_Wager_Listing_2"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          Office: office,
          Group: group,
          Book: book,
          LineType: lineType,
          AgentFrom: agentFrom,
          AgentTo: agentTo,
          Distributor: distributor,
          Player: player,
          User: user,
          Station: station,
          Ip: ip,
          SameIp: sameIp,
          HigherThan: higherThan,
          WagerTypes: wagerType,
          Sport: sport,
          League: league,
          AgentLine: agentLine,
          FreePlay: freePlay,
          OpenPlay: openPlay,
          PastPost: pastPost,
          WagerStatus: wagerStatus,
          PlayerType: playerType,
          AllPlacedDate: allPlacedDate,
          StartPlacedDate: startPlacedDate,
          EndPlacedDate: endPlacedDate,
          AllSettledDate: allSettledDate,
          StartSettledDate: startSettledDate,
          EndSettledDate: endSettledDate,
          WithDetailsIn: withDetailsIn,
          WagerPlaced: wagerPlaced,
          OrderBy: orderBy,
        })}
        getGroupOrders={[(key, items) => items[0]?.player]}
        getProcess={(data) => [
          {
            ...data?.[0],
            description: data?.[0]?.completeDescription,
            score: data?.[0]?.loginName,
            phoneIP:
              data?.[0]?.phoneLine !== "-1"
                ? data?.[0]?.phoneLine
                : data?.[0]?.iP,
            resultDetail: data?.[0]?.neto,
          },
          ...data.map((item) => ({
            ...item,
            player: "",
            ticket: "",
            placedDate: item.idSport,
            riskAmount: "",
            winAmount: "",
            description: item.detailDescription,
          })),
        ]}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="player">
          Player
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="ticket">
          Ticket
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="placedDate"
          dataFormat={dateTimeReportFormatter}
        >
          Placed Date / Sport
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="description">
          Complete Description
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="riskAmount"
          dataFormat={decimalInvertedReportFormatter}
        >
          Risk
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="winAmount"
          dataFormat={decimalInvertedReportFormatter}
        >
          Win
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="resultDetail"
          dataFormat={decimalInvertedReportFormatter}
        >
          Neto / Result
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="score">
          User / Score
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="phoneIP">
          Phone / IP
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default WagersListing;
